import { Injectable } from '@angular/core';
import {SimpleUser} from "./user.service";
import {SimpleSubject} from "./subject.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Page} from "./api.service";
import {environment} from "../../environments/environment";
import { resetPassword } from 'aws-amplify/auth';

export type RoleType = 'COORDINATOR' | 'TEACHER' | 'OBSERVER' ;

export class RoleKey {
  subjectId: string;
  email: string ;

  public constructor(subjectId: string, email: string) {
    this.subjectId = subjectId ;
    this.email = email ;
  }
}

export class Role {

  id?: string;
  email: string ;
  user?: SimpleUser;
  subject?: SimpleSubject ;
  type: RoleType ;
  createdAt?: Date ;

  public constructor(email: string, givenName:string, familyName: string, type: RoleType) {
    this.email = email ;
    this.user = new SimpleUser(givenName, familyName)
    this.type = type ;
  }
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  

  constructor(private http: HttpClient) { }

  getMyRoles(page: number ): Observable<Page<Role>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<Role>>(
      `${environment.apiHost}/roles`,
      {params}
    ) ;
  }

  getSubjectRoles(subjectId: string, page: number ): Observable<Page<Role>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<Role>>(
      `${environment.apiHost}/subjects/${subjectId}/roles`,
      {params}
    ) ;
  }

  getRole(id: string): Observable<Role> {
    return this.http.get<Role>(
      `${environment.apiHost}/roles/${id}`
    ) ;
  }

  getMySubjectRole(subjectId: string): Observable<Role> {
    return this.http.get<Role>(
      `${environment.apiHost}/subjects/${subjectId}/roles/mine`,
    ) ;
  }

  getMyRoomRole(roomId: string): Observable<Role> {
    return this.http.get<Role>(
      `${environment.apiHost}/rooms/${roomId}/roles/mine`,
    ) ;
  }

  createNewRole(subjectId: string, role: Role): Observable<Role> {
    return this.http.post<Role>(
      `${environment.apiHost}/subjects/${subjectId}/roles`,
      role
    ) ;
  }

  updateRole(role: Role): Observable<Role> {
    return this.http.patch<Role>(
      `${environment.apiHost}/subjects/${role.subject!.id!}/roles/${role.id!}`,
      role
    );
  }

  deleteRole(role: Role): Observable<Role> {
    return this.http.delete<Role>(
      `${environment.apiHost}/subjects/${role.subject!.id!}/roles/${role.id!}`
    );
  }
}
